module.exports = __webpack_public_path__ + "ccd796b31c.jpg";